import "./my-orders.styles.scss";

import OrderInformation from "../../components/order-information/order-information.component";
import dayjs from "dayjs";
import { getUserOrders } from "../../service/order.service";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/user.context";
import { useNavigate } from "react-router-dom";
import { convertToBrazilianDate } from "../../service/date.service";
import {
  Button,
  Card,
  Link,
  useTheme,
  Stack,
  Box,
  Typography,
  Divider,
  Container,
  TextField,
  InputAdornment,
} from "@mui/material";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";

const MOKED_DATA = [
  {
    id: 123,
    createdAt: Date.now(),
    status: "APPROVED",
    insurance: {
      insuranceCompany: "affinity",
      insuranceName: "Affinity Ed Insurance",
    },
    passengers: [
      {
        fullName: "Edson Archela",
        cpf: "05189699919",
        birthDate: "2000-01-01",
      },
    ],
    tripInfo: {
      destination: "Ásia",
      boardingDate: Date.now(),
      arrivalDate: Date.now(),
    },
    paymentInfo: {
      method: "credit-card",
      creditCardInfo: {
        banner: "Bruce",
        fullName: "Bruce Banner",
        number: "707070",
        installments: "123",
      },
      total: 1.99,
      qrCodeBase64: "pay-84e2a5b0-9b6d-4b2d-ae91-360c72b5c278",
      qrCodeString: null,
    },
    vouchers: [{ url: "lkadfjhgipashbpçasnpb" }],
  },
  {
    id: 1234,
    createdAt: Date.now(),
    status: "REPROVED",
    insurance: {
      insuranceCompany: "affinity",
      insuranceName: "Affinity Ed Insurance",
    },
    passengers: [
      {
        fullName: "Edson Archela",
        cpf: "05189699919",
        birthDate: "2000-01-01",
      },
    ],
    tripInfo: {
      destination: "Ásia",
      boardingDate: Date.now(),
      arrivalDate: Date.now(),
    },
    paymentInfo: {
      method: "pix",
      creditCardInfo: {
        banner: "Bruce",
        fullName: "Bruce Banner",
        number: "707070",
        installments: "123",
      },
      total: 1.99,
      qrCodeBase64: null,
      qrCodeString: null,
    },
    vouchers: [{ url: "lkadfjhgipashbpçasnpb" }],
  },
  {
    id: 1235,
    createdAt: Date.now(),
    status: "Pendente",
    insurance: {
      insuranceCompany: "affinity",
      insuranceName: "Affinity Ed Insurance",
    },
    passengers: [
      {
        fullName: "Edson Archela",
        cpf: "05189699919",
        birthDate: "2000-01-01",
      },
    ],
    tripInfo: {
      destination: "Ásia",
      boardingDate: Date.now(),
      arrivalDate: Date.now(),
    },
    paymentInfo: {
      method: "pix",
      creditCardInfo: {
        banner: "Bruce",
        fullName: "Bruce Banner",
        number: "707070",
        installments: "123",
      },
      total: 1.99,
      qrCodeBase64: null,
      qrCodeString: null,
    },
    vouchers: [{ url: "lkadfjhgipashbpçasnpb" }],
  },
];

const MyOrders = () => {
  const navigate = useNavigate();

  const { authUser } = useContext(UserContext);

  const [orderList, setOrderList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [idToFilter, setIdToFilter] = useState("");

  // NOTE:FOR MOCK
  useEffect(() => {
    if (!authUser) {
      navigate("/authentication");
      return;
    }
  }, [authUser, navigate]);

  useEffect(() => {
    const fetchUserOrders = async () => {
      if (!authUser) return; // Don't fetch if user is not authenticated

      console.log("Setting loading to true");
      setLoading(true);
      try {
        const token = await authUser.getIdToken();
        console.log("Fetching user orders...");
        const orders = await getUserOrders(token, 10); // Limit to 10 orders initially
        console.log("Orders received:", orders);
        setOrderList(orders || []); // Ensure orders is always an array
      } catch (error) {
        console.error("Error fetching user orders:", error);
        setOrderList([]); // Set empty array on error
      } finally {
        console.log("Setting loading to false");
        setLoading(false);
      }
    };

    if (authUser) {
      fetchUserOrders();
    }
  }, [authUser]);

  const handleFilterChange = (event) => {
    setIdToFilter(event.target.value);
  };

  const filterById = (order) => {
    if (!!idToFilter) {
      return String(order.id).indexOf(idToFilter) !== -1;
    }
    return true;
  };

  const theme = useTheme();

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        margin: "2rem auto",
      }}
    >
      <TextField
        label={"Digite o Nº do pedido"}
        variant="outlined"
        size="small"
        onChange={handleFilterChange}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon color={theme.palette.grey[700]} />
              </InputAdornment>
            ),
          },
        }}
        sx={{
          width: "fit-content",
          "& .MuiOutlinedInput-root": {
            backgroundColor: (theme) => theme.palette.grey[50],
            "& fieldset": {
              borderRadius: "8px",
            },
          },
        }}
      />

      {loading ? (
        <Card
          elevation={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: "0.5rem", sm: "1rem", md: "2rem" },
            margin: 0,
            backgroundColor: `${theme.palette.grey[50]}`,
            boxShadow: "-8px 8px 30px -15px rgba(0,0,0,0.3)",
            paddingBottom: "2rem",
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{
              padding: { xs: "0.75rem 1rem", sm: "1rem 2rem" },
              backgroundColor: `${theme.palette.text.primary}`,
              color: "white",
            }}
          >
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              Carregando seus pedidos...
            </Typography>
          </Stack>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems={"center"}
            sx={{
              padding: { xs: "0 1rem", sm: "0 2rem" },
            }}
            mt={"1rem"}
          >
            <Typography variant="body2">
              Aguarde enquanto buscamos suas informações
            </Typography>
          </Stack>
        </Card>
      ) : orderList && orderList.length > 0 ? (
        orderList
          .filter(filterById)
          .map((order) => <OrderInformation key={order.id} order={order} />)
      ) : (
        <Card
          elevation={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: "0.5rem", sm: "1rem", md: "2rem" },
            margin: 0,
            backgroundColor: `${theme.palette.grey[50]}`,
            boxShadow: "-8px 8px 30px -15px rgba(0,0,0,0.3)",
            paddingBottom: "2rem",
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{
              padding: { xs: "0.75rem 1rem", sm: "1rem 2rem" },
              backgroundColor: `${theme.palette.text.primary}`,
              color: "white",
            }}
          >
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              Você não tem nenhuma compra registrada para a conta acessada
            </Typography>
            <Typography variant="body1">
              {convertToBrazilianDate(dayjs())}
            </Typography>
          </Stack>

          <Stack
            direction="column"
            justifyContent="center"
            alignItems={"center"}
            sx={{
              padding: { xs: "0 1rem", sm: "0 2rem" },
            }}
            mt={"1rem"}
          >
            <Typography variant="body2">
              Suas próximas compras aparecerão aqui
            </Typography>
          </Stack>
        </Card>
      )}
    </Container>
  );
};

export default MyOrders;
